import React, { useState, useEffect, useContext, useCallback } from "react";
import { useAuth } from "../contexts/AuthContext";

import { Route, Link, Switch, Redirect } from "react-router-dom";

import SideMenuContext from "../../common/context/sideMenuContext";

import SideBarAnamgis from "./fields/sidebar";
import MyAccount from "../../common/components/myaccount";
import LandRegister from "../../common/components/landRegister";
import Payments from "../../common/components/payments";
import Login from "./Login";
import ApplicationTraking from "../../common/components/applicationTraking";
import Contact from "../../common/components/contact";
import AboutUs from "../../common/components/about";
import OneTimeLoginForm from "../../common/components/forms/onetimeLoginform";
import StandardLoginForm from "../../common/components/forms/standardLoginForm";
import sideMobileMenu from "../../common/components/sideMobileMenu";
import AdminUtils from "./AdminUtils";
import "./home.css";

const Home = ({ location, match, history, generalEndPoint, usersEndPoint }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const [showWellcome, setWellcome] = useState(true);
  const sideMenuContext = useContext(SideMenuContext);

  // Auto-redirect to login if not authenticated (but wait for auth to load)
  useEffect(() => {
    // Don't redirect while still loading auth state
    if (isLoading) return;

    if (!isAuthenticated && !location.pathname.includes("/login")) {
      console.log("Not authenticated, redirecting to login");
      history.push("/login");
      return;
    }
  }, [isAuthenticated, isLoading, location.pathname, history]);

  const hideFirstMessage = useCallback(() => {
    setWellcome(false);
  }, []);

  let menues = sideMenuContext.menues;

  const componentsMap = {
    LandRegister,
    Payments,
    ApplicationTraking,
    MyAccount,
    AboutUs,
    Contact,
    SideBarAnamgis,
    sideMobileMenu,
    Login,
    OneTimeLoginForm,
    StandardLoginForm,
  };

  // SIMPLIFIED: Only menu loading
  useEffect(() => {
    console.log("Loading menus for Home component");

    function getMenues() {
      if (!menues || menues.length === 0) {
        sideMenuContext.onHandleSideMenu();
        menues = sideMenuContext.menues;
        console.log("Menus loaded");
      }
    }

    getMenues();
  }, [sideMenuContext, menues]);

  console.log("MENUES=", menues);

  return (
    <div>
      <div id="SideBarMenuDivAdmin">
        <SideBarAnamgis
          handleClick={hideFirstMessage}
          currentLocation={location.pathname}
        />
      </div>

      <div id="workArea">
        {showWellcome && <AdminUtils />}

        {menues.map((mItem) => (
          <Route
            path={mItem.to}
            key={mItem.id}
            component={componentsMap[mItem.objectName]}
          />
        ))}
      </div>
    </div>
  );
};

export default Home;
